module.exports = __webpack_public_path__ + "img/icon1.25eb64f.png";